import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { AddUsersDestiny, AddCompanyDestiny } from './modals/mails';
import { ShowNotification } from '../Notifications';
import { fetchDataPostAsync } from '../../model/axios/fetchs';
import Editor from '../blogs/post/postEditor/index';

function Mailing({ className }) {
  const platform = useSelector((state) => state.platform);

  const [state, setState] = useState({
    CurrentMail: 1,
    currentText: '',
    ModalText: false,
    ModalImage: false,
    ModalLink: false,
    htmlBody: [],
    subject: '',
    ModalAddUsers: false,
    ModalAddCompanies: false,
    ConfirmSend: false,
    SendingMail: false,
    editorData: '',
    ConfirmSendUser: false,
    ConfirmSendCompany: false,
  });

  const SubNavigation = (p) => {
    setState((prevState) => ({
      ...prevState,
      CurrentMail: p,
    }));
  };

  const capitalize = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  const SubjectChange = (e) => {
    const { value } = e.target;
    setState((prevState) => ({
      ...prevState,
      subject: value,
    }));
  };

  const addDestiny = () => {
    if (state.subject === '') {
      ShowNotification('warning', 'Debes de agregar el asunto del correo', 'Sujeto incorrecto');
    } else {
      setState((prevState) => ({
        ...prevState,
        [state.CurrentMail === 2 ? 'ConfirmSendUser' : 'ConfirmSendCompany']: true,
      }));
    }
  };

  const handleClose = () => {
    setState((prevState) => ({
      ...prevState,
      [state.CurrentMail === 2 ? 'ConfirmSendUser' : 'ConfirmSendCompany']: false,
    }));
  };

  const sendMail = async (htmlBody, mails) => {
    try {
      setState((prevState) => ({ ...prevState, SendingMail: true }));
      const sendable = { email: mails, body: htmlBody, subject: state.subject, fromEmail: platform.fromEmail };
      await fetchDataPostAsync('sendMultipleMail', sendable);
      setState((prevState) => ({
        ...prevState,
        SendingMail: false,
        [state.CurrentMail === 2 ? 'ConfirmSendUser' : 'ConfirmSendCompany']: true,
        editorData: '',
        subject: '',
      }));
      ShowNotification('success', 'Se envio el correo de manera correcta', '¡Listo!');
    } catch (e) {
      console.error(e);
    }
  };

  const htmlStyles = `<html><head> <style>img{width: 40%; margin: 45px 0px}h1{font-size: 2rem;}
    h2{font-size: 1.65rem}p{ font-size: 1.2rem;}</style></head><body>`;
  const htmlClose = `</body></html>`;
  const prepareHtmlBody = (mails) => {
    try {
      const html = `${htmlStyles} ${state.editorData} ${htmlClose}`;
      sendMail(html, mails).then();
    } catch (e) {
      console.error(e);
    }
  };

  const handleChangeEditor = (html) => {
    setState((prevState) => ({
      ...prevState,
      editorData: html,
    }));
  };

  return (
    <>
      <div className={`${className} mailingContainer`}>
        <div className="mailNavBar">
          <div className="configCardTitleCont">
            <p className="configCardTitle">Mailing</p>
            <p className="configCardDesc">
              Envia notificaciones, avisos o invitaciones a todos tus estudiantes y empresas. Recuerda que ellos no
              podrán responder al correo de ser necesario agrega un correo de contacto al cuerpo del mensaje.
            </p>
          </div>
          <div className="mailOptions">
            <p
              className={state.CurrentMail === 1 ? 'mailNavItemActive' : 'mailNavItem'}
              onClick={() => SubNavigation(1)}>
              Empresas
            </p>
            <p
              className={state.CurrentMail === 2 ? 'mailNavItemActive' : 'mailNavItem'}
              onClick={() => SubNavigation(2)}>
              {capitalize(platform.userTypeText)}
            </p>
          </div>
        </div>
        <div className="mailPage">
          <div className="mailBody">
            <div className="inputBox100">
              <input
                className="subjectInput"
                onChange={SubjectChange}
                value={state.subject}
                placeholder="Ingresa el asunto del correo"
              />
            </div>
            <div className="mailBodyContainer">
              <hr />
              <Editor handleChange={handleChangeEditor} html={state.editorData} placeholder="Cuerpo del mensaje ..." />
            </div>
          </div>
        </div>
        <div className="mailButtonContainer">
          <button className="mailDestinyButton" onClick={addDestiny}>
            Agregar destinatario
          </button>
        </div>
      </div>
      <AddUsersDestiny open={state.ConfirmSendUser} onClose={handleClose} sendMail={prepareHtmlBody} />
      <AddCompanyDestiny open={state.ConfirmSendCompany} onClose={handleClose} sendMail={prepareHtmlBody} />
    </>
  );
}

export default styled(Mailing)`
  .mailing-card-text {
    background-color: black;
    width: 90%;
    color: white;
    font-size: 2rem;
    font-weight: 700;
    margin-right: auto;
    margin-left: auto;
    display: block;
    padding-left: 6px;
    padding-right: 6px;
    padding-top: 5px;
    padding-bottom: 5px;
  }
  .mailing-add-components-container {
    width: 100%;
    display: flex;
    padding: 10px;
    justify-content: space-evenly;
    align-items: center;
    margin-top: 10px;
    margin-bottom: 20px;
  }
  .mailing-add-text-area {
    width: 80%;
    display: flex;
    flex-direction: row;
    margin-left: auto;
    margin-right: auto;
    justify-content: center;
    align-items: center;
  }
  .mailing-add-text-title {
    font-size: 1.6rem;
    font-weight: 700;
    text-align: start;
  }
  .mailing-add-text-button {
    font-size: 1.6rem;
    font-weight: 600;
    background-color: var(--button-color);
    color: var(--white-color);
  }
  .mailing-add-text-text-area {
    resize: none;
    width: 50%;
    display: inline-block;
    font-size: 1.5rem;
    margin-left: 20px;
    margin-right: 20px;
  }
  .mailing-preview-text {
    font-size: 1.8rem;
    text-align: start;
    white-space: break-spaces;
    padding: 5px;
    width: 100%;
  }
  .mailing-preview-text:hover {
    cursor: pointer;
    border-radius: 6px;
  }
  .mailing-preview-image {
    width: 40%;
    display: block;
    margin-left: auto;
    margin-right: auto;
    padding: 10px;
  }
  .mailing-preview-subject {
    font-size: 1.7rem;
    text-align: start;
    display: inline-block;
  }
  .mailing-loading-image-label {
    display: inline-block;
    font-size: 1.8rem;
    margin-left: 20px;
    margin-right: 20px;
    font-weight: 300;
    margin-bottom: 10px;
    color: var(--success-text);
  }
  .mailing-button-add-image {
    font-size: 1.6rem;
    font-weight: 700;
    background-color: darkblue;
    color: white;
    padding-left: 30px;
    padding-right: 30px;
    padding-bottom: 7px;
    padding-top: 7px;
  }
  .mailing-button-add-text {
    font-size: 1.6rem;
    font-weight: 700;
    background-color: black;
    color: white;
    padding-left: 30px;
    padding-right: 30px;
    padding-bottom: 7px;
    padding-top: 7px;
  }
  .mailing-button-add-link {
    font-size: 1.6rem;
    font-weight: 700;
    background-color: darkslategray;
    color: white;
    padding-left: 30px;
    padding-right: 30px;
    padding-bottom: 7px;
    padding-top: 7px;
  }
  .mailing-subject-container {
    width: 75%;
    padding: 8px;
    margin-left: auto;
    margin-right: auto;
    display: block;
  }
  .mailing-label {
    font-size: 1.7rem;
    text-align: start;
    padding-left: 5px;
    padding-right: 5px;
    width: 10%;
    display: inline-block;
  }
  .mailing-label-container {
    width: 100%;
    border-bottom: solid 1px var(--header-background);
    margin-top: 5px;
    margin-bottom: 5px;
  }
  .mailing-body-label {
    font-size: 1.7rem;
    text-align: start;
    padding-left: 5px;
    width: 100%;
    display: block;
    margin-top: 10px;
    margin-bottom: 10px;
  }
  .mailing-add-subject-container {
    width: 90%;
    margin-left: auto;
    margin-right: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 35px;
    margin-bottom: 45px;
  }
  .mailing-body-container {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 10px;
    margin-right: auto;
    margin-left: auto;
    margin-top: 20px;
    text-align: center;
    border: solid 1px var(--header-background);
  }
  .mailing-input {
    font-size: 1.7rem;
    width: 65%;
    padding-left: 4px;
    padding-right: 4px;
    padding-top: 2px;
    padding-bottom: 2px;
    display: inline-block;
  }
  .mailing-preview-link {
    font-size: 1.6rem;
    text-align: start;
    padding: 6px;
    background-color: var(--font-text-cyan);
    color: white;
    font-weight: 700;
    margin-left: auto;
    margin-right: auto;
    padding-top: 7px;
    margin-bottom: 7px;
    margin-top: auto;
    margin-bottom: auto;
  }
  .mailing-preview-link-container {
    width: 100%;
    padding: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .mailing-preview-link-container:hover {
    border: solid 1px #eeeeee;
    cursor: pointer;
    padding: 5px;
    border-radius: 6px;
  }
  .mailing-preview-link-container:hover .mailing-preview-icon {
    color: brown;
    background-color: white;
    padding: 1.5px;
    border-radius: 4px;
  }
  .mailing-preview-icon {
    font-size: 2.7rem;
    color: white;
    margin-right: 20px;
  }
  .mailing-select-destiny {
    font-size: 1.7rem;
    padding-left: 2px;
    padding-right: 2px;
    padding-top: 3px;
    padding-bottom: 3px;
    width: 30%;
  }
  .mailing-warning-noreplay {
    font-size: 1.7rem;
    font-weight: bold;
    color: darkgoldenrod;
    width: 55%;
    padding: 4px;
  }
  .flex-direction-column {
    flex-direction: column;
  }
  .mailing-checkbox-destiny {
    width: 15px;
    height: 15px;
    line-height: 12px;
    display: block;
    margin-left: auto !important;
    margin-right: auto !important;
  }
  .mailing-sendmails-button {
    font-size: 1.8rem;
    padding-left: 10rem;
    padding-right: 10rem;
    background-color: #5373fc;
    color: white;
    font-weight: 600;
  }
`;
